import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AccordionClass } from ".";

interface BibliographyAccordionProps {
  bibliographyCalculated: string | null;
  t: (key: string) => string;
}

export function BibliographyAccordion({
  bibliographyCalculated,
  t,
}: BibliographyAccordionProps) {
  if (!bibliographyCalculated) return null;

  return (
    <AccordionItem value="bibliographie">
      <AccordionTrigger>
        {t("singleArtworkSubtitleBibliography")}
      </AccordionTrigger>
      <AccordionContent>
        <div
          dangerouslySetInnerHTML={{
            __html: bibliographyCalculated,
          }}
          className={AccordionClass}
        />
      </AccordionContent>
    </AccordionItem>
  );
}
